import React from 'react'

export default function LogosCarousel({ logos }) {
  return (
    <div className="relative w-full overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
      <div className="flex w-max animate-marquee items-center gap-4 py-4 sm:gap-6 lg:gap-8 hover:[animation-play-state:paused]">
        {[...logos, ...logos].map((logo, index) => (
          <div
            key={`${logo.name}-${index}`}
            className="flex h-16 w-28 flex-shrink-0 items-center justify-center rounded-xl bg-white p-3 shadow-md sm:h-20 sm:w-32 sm:p-4 lg:h-28 lg:w-48"
          >
            <img
              src={logo.src}
              alt={logo.name}
              className="h-full w-full object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  )
}
